// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"B70BJQ","container":"HJ8_Zz"};